import { useCallback } from 'react';

import { fetchTableLevelMessagesAction } from '../apiActions/fetchTableLevelMessagesAction';
import { useCoreDispatch } from '../CoreStore';
import { useChatSlice } from '../slices/chat/selectors';
import { useConfigSlice } from '../slices/config/selectors';
import { useSettingsSlice } from '../slices/settings/selectors';

export const HISTORY_MESSAGES_COUNT = 20;

// Fetch chat history from tableLevelMessages API
export const useChatHistoryFetcher = (essential: boolean): (() => void) => {
  const casinoId = useConfigSlice.session()?.casinoId ?? '';
  const chatSubscriptionState = useChatSlice.getChatSubscriptionState();
  const chatUrl = useConfigSlice.env()?.chat;
  const isChatSubscribed = chatSubscriptionState === 'SUBSCRIBED';
  const isGameChatHistoryFetched = useChatSlice.getIsChatHistoryFetched();
  const language = useSettingsSlice.currentLanguage();
  const showOtherMessages = useConfigSlice.showOtherMessages();
  const tableId = useConfigSlice.tableId();
  const userId = useConfigSlice.userId();

  const dispatch = useCoreDispatch();

  return useCallback(() => {
    if (!isGameChatHistoryFetched && isChatSubscribed && chatUrl && tableId && userId && casinoId) {
      dispatch(
        fetchTableLevelMessagesAction({
          casinoId,
          essential,
          language,
          offset: 0,
          recordsPerPage: HISTORY_MESSAGES_COUNT,
          showOtherMessages: showOtherMessages,
          tableId: tableId,
          tagMessage: 'GAME_USER',
          url: `${chatUrl}/api/fetchTableLevelMessages`,
          userId: userId,
        })
      );
    }
  }, [
    casinoId,
    chatUrl,
    dispatch,
    essential,
    isChatSubscribed,
    isGameChatHistoryFetched,
    language,
    showOtherMessages,
    tableId,
    userId,
  ]);
};
